module.exports = __webpack_public_path__ + "media/images/athletes/2028-a1655efe63467c0365d6583ef225427a.png";